import { QueryState } from "src/app/core/models/query.model";
import { ITableColumn } from "src/app/core/models/table.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const WATER_SUPPLY_COMPANY_ENDPOINT = 'water-supply-company';
export const WATER_SUPPLY_COMPANY_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(WATER_SUPPLY_COMPANY_ENDPOINT);

export const WATER_SUPPLY_JOB_ENDPOINT = 'water-supply-job';
export const WATER_SUPPLY_JOB_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(WATER_SUPPLY_JOB_ENDPOINT);


export const WATER_SUPPLY_STAFF_ENDPOINT = 'water-supply-staff';
export const WATER_SUPPLY_STAFF_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(WATER_SUPPLY_STAFF_ENDPOINT);

export const WATER_SUPPLY_SYSTEM_ENDPOINT = 'water-supply-system';
export const WATER_SUPPLY_SYSTEM_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(WATER_SUPPLY_SYSTEM_ENDPOINT);

export const waterSupplyStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const waterSupplySystemStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const WATER_SUPPLY_STAFF_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    type:'text'
  },
  {
    name: 'lastName',
    label: 'Cognome',
    field: 'lastName',
    type:'text'
  },
  {
    name: 'firstName',
    label: 'Nome',
    field: 'firstName',
    type:'text'
  },
  {
    name: 'telephone',
    label: 'Telefono',
    field: 'telephone',
    type:'text'
  },
  {
    name: 'memberType',
    label: 'Tipologia',
    field: 'memberType',
    type:'cell',
    cell:(el:any)=>el.memberType === "INTERNAL" ? 'Interno' : 'Esterno'
  },
  {
    name: 'email',
    label: 'E-mail',
    field: 'email',
    type:'text'
  },
  {
    name: 'waterSupplyJob',
    label: 'Ruolo',
    field: 'waterSupplyJob',
    cell:(el:any) => el.waterSupplyJob?.name

  },
]

export const WATER_SUPPLY_STAFF_VISIBLE_COLUMNS = [
  'select',
  'lastName',
  'firstName',
  'telephone',
  'email',
  'memberType',
  'waterSupplyJob',
  'azioni'

]

export const WATER_SUPPLY_STAFF_FILTER_COLUMNS: ITableColumn[] = [

  {
    name: 'lastName',
    label: 'Cognome',
    field: 'lastName',
    type:'text'
  },
  {
    name: 'firstName',
    label: 'Nome',
    field: 'firstName',
    type:'text'
  },
  {
    name: 'telephone',
    label: 'Telefono',
    field: 'telephone',
    type:'text'
  },
  {
    name: 'email',
    label: 'E-mail',
    field: 'email',
    type:'text'
  },
  {
    name: 'waterSupplyJob',
    label: 'Posizione lavorativa',
    field: 'waterSupplyJob',
    type:'select',
    options: []
  },
];
